import { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import About from './Pages/About';
import Register from './Pages/Register';
import { ExamCompassContextProvider } from './Context/context';
import Login from './Pages/Login';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import Term from './Pages/Term';
import Forgotpassword from './Pages/ForgotPassword';
import ChangePassword from './Pages/ChangePassword';
import SuccessOne from './Pages/SuccessOne';
import SuccessTwo from './Pages/SuccessTwo';
import ConfirmPayment from './Pages/ConfirmPayment';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from './Pages/NotFound';
import AuthorisationRoute from './Pages/Auth';

function App() {
  const MainRoutes = () => {
    const [currentPage, setCurrentPage] = useState<string>(() => {
      return localStorage.getItem('currentPage') || 'home';
    });

    const [showPassword, setShowPassword] = useState<boolean>(false);

    const location = useLocation();
    // Pages where Navbar and Footer should not appear
    const excludedRoutes = [
      '/register',
      '/login',
      '/change-password',
      '/forgot-password',
      '/reset-password',
      '/email-verification',
      '/reset-verificaion',
      '/confirmPayment',
    ];

    // Check if the current route is a 404 page
    const isNotFoundPage =
      location.pathname !== '/' &&
      !excludedRoutes.includes(location.pathname) &&
      !['/about', '/terms-and-conditions'].includes(location.pathname);
    const isExcludedRoute =
      excludedRoutes.includes(location.pathname) || isNotFoundPage;

    return (
      <>
        {!isExcludedRoute && (
          <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
        )}
        <Routes>
          <Route path='/' element={<Home setCurrentPage={setCurrentPage} />} />
          <Route path='/auth' element={<AuthorisationRoute />} />
          <Route path='/about' element={<About />} />
          <Route
            path='/register'
            element={
              <Register
                setCurrentPage={setCurrentPage}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
              />
            }
          />
          <Route path='/email-verification' element={<SuccessOne />} />
          <Route path='/reset-verification' element={<SuccessTwo />} />
          <Route
            path='/login'
            element={
              <Login
                showPassword={showPassword}
                setShowPassword={setShowPassword}
              />
            }
          />
          <Route path='/forgot-password' element={<Forgotpassword />} />
          <Route
            path='/reset-password'
            element={
              <ChangePassword
                showPassword={showPassword}
                setShowPassword={setShowPassword}
              />
            }
          />
          <Route path='/terms-and-conditions' element={<Term />} />
          <Route path='/confirmPayment' element={<ConfirmPayment />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
        {!isExcludedRoute && <Footer setCurrentPage={setCurrentPage} />}
      </>
    );
  };

  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <ExamCompassContextProvider>
        <ToastContainer draggable={false} transition={Zoom} />
        <ScrollToTop />
        <MainRoutes />
      </ExamCompassContextProvider>
    </BrowserRouter>
  );
}

export default App;
